import CardTorn from '@/assets/images/2-target-your-mate-card-torn.png';

export const ClueStep2 = () => <img src={CardTorn} alt="" className="max-w-2/3 w-64 h-auto rounded-lg drop-shadow-white drop-shadow-[0_0_40px]" />;
